import { SpeakerWithDetails } from '@/context/TranscriptContext/TranscriptContextTypes';
import { getSpeakerNameAndTitle } from '@/Pages/Clip/CompositePlayer/SpeakerVideoUtils';
import { AlignedRecordings } from '@/App/remotion/MainPlayer/stores/alignedRecordings';
import { isEntityScreenshare } from '@/libs/activityUtils';

export const getSpeakerName = (
  recording: AlignedRecordings,
  speakerDetails: Record<string, SpeakerWithDetails>
): string => {
  if (isEntityScreenshare(recording.entity)) {
    return recording.user.first_name + ' ' + recording.user.last_name + "'s Screenshare";
  }
  // TODO: @@HiteshChoudhary0098 this needs to be revisited. What backend stopped sending types for transcript mapping.
  // @ts-ignore
  const speakerId = recording.transcript_mapping?.speaker_labels[0];
  if (!speakerId || !speakerDetails[speakerId]) {
    return '';
  }

  const { name } = getSpeakerNameAndTitle(speakerDetails[speakerId]);

  return name;
};
